/* eslint arrow-body-style: 0 */
import ContactsView from './components/ContactsView';
import ContactManageView from './pages/ContactManageView';
import { frontendURL } from '../../../helper/URLHelper';
import { FEATURE_FLAGS } from '../../../featureFlags';
import {requireAuth} from "../dashboard.routes";

export const routes = [
  {
    path: frontendURL('accounts/:accountId/contacts'),
    name: 'contacts_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    beforeEnter: requireAuth,
    meta: {
      permission: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    }
  },
  {
    path: frontendURL('accounts/:accountId/contacts/custom_view/:id'),
    name: 'contacts_segments_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    props: route => {
      return { segmentsId: route.params.id };
    },
    beforeEnter: requireAuth,
    meta: {
      permission: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    }
  },
  {
    path: frontendURL('accounts/:accountId/labels/:label/contacts'),
    name: 'contacts_labels_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactsView,
    props: route => {
      return { label: route.params.label };
    },
    beforeEnter: requireAuth,
    meta: {
      permission: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    }
  },
  {
    path: frontendURL('accounts/:accountId/contacts/:contactId'),
    name: 'contact_profile_dashboard',
    roles: ['administrator', 'agent'],
    component: ContactManageView,
    props: route => {
      return { contactId: route.params.contactId };
    },
    beforeEnter: requireAuth,
    meta: {
      permission: FEATURE_FLAGS.CRM,
      permissions: ['administrator', 'agent', 'contact_manage'],
    }
  },
];
